import React, { useState } from "react";
import Box from "../../../Unknown/Box";
import { GridColDef } from "../../../Unknown/DataGrid";
import SimpleOptionsMenu from "../../../Unknown/SimpleOptionsMenu";
import { AppointmentReport } from "../types";
import getOptionalArrayItem from "../../../../common/getOptionalArrayItem";

type ColumnTranslations = {
  btnDownload: string;
  btnUnexpectedFindings: string;
  btnConfirmUnexpectedFindings: string;
  btnView: string;
};

type ColumnsParams = {
  translations: ColumnTranslations;
  headerClassName: string;
  onConfirmReceiptClick: (id: string) => void;
  onUnexpectedFindingsClick: (id: string) => void;
  onViewClick: (id: string) => void;
};

const useColumnOptions = ({
  headerClassName,
  translations,
  onConfirmReceiptClick,
  onUnexpectedFindingsClick,
  onViewClick,
}: ColumnsParams): GridColDef<AppointmentReport, string> => {
  const [isDownloading, setIsDownloading] = useState(false);

  const {
    btnDownload,
    btnUnexpectedFindings,
    btnConfirmUnexpectedFindings,
    btnView,
  } = translations;

  return {
    field: "options",
    disableColumnMenu: true,
    headerName: "",
    sortable: false,
    headerClassName,
    width: 80,
    renderCell: ({ row }) => {
      if (row.type === "pdf") {
        const options = [
          {
            text: btnDownload,
            isLoading: isDownloading,
            onClick: async () => {
              setIsDownloading(true);
              await row.onDownloadClick();
              setIsDownloading(false);
            },
          },
          ...getOptionalArrayItem(!row.hasUnexpectedFindings, {
            text: btnUnexpectedFindings,
            onClick: () => onUnexpectedFindingsClick(row.id),
          }),
          ...getOptionalArrayItem(
            row.hasUnexpectedFindings && !row.isReceiptConfirmed,
            {
              text: btnConfirmUnexpectedFindings,
              onClick: () => onConfirmReceiptClick(row.id),
            },
          ),
        ];

        return (
          <Box display="flex" justifyContent="center" width="100%">
            <SimpleOptionsMenu options={options} />
          </Box>
        );
      }

      if (row.type === "ai") {
        const options = [
          {
            text: btnView,
            onClick: () => onViewClick(row.id),
          },
        ];

        return (
          <Box display="flex" justifyContent="center" width="100%">
            <SimpleOptionsMenu options={options} />
          </Box>
        );
      }

      return (
        <Box display="flex" justifyContent="center" width="100%">
          <SimpleOptionsMenu options={[]} />
        </Box>
      );
    },
  };
};

export default useColumnOptions;
